module.exports = __webpack_public_path__ + "img/mic.843100a4.svg";